module.exports = __webpack_public_path__ + "img/DasParadiesDerVögel.f1b3ff0f.jpg";